import React from "react"

const UserIcon = ({dark = true}) => {

    return (
        <i className="bi-person-circle" style={{ fontSize: "1.5rem", color: dark ? "black" : "white" }}></i>
    )
}

export default UserIcon